import React from "react";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { formatCurrency } from "utils/currencyFormat";
import { formatNumber } from "utils/currencyFormat";

class LanThanhToanView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    let { itemShow } = this.state;
    let { showPhiKho, Type, StatusPaidHo } = this.props;

    let showTienGop = StatusPaidHo === 1 && Type === 2;
    let showLai =
      Type !== 2 ||
      (Type === 2 && StatusPaidHo === 2) ||
      (StatusPaidHo === 3 && Type === 2);
    let showGoc =
      Type !== 2 ||
      (Type === 2 && StatusPaidHo === 2) ||
      (StatusPaidHo === 3 && Type === 2);
    let showGop =
      (Type === 2 && StatusPaidHo === 3) ||
      (Type == 3 && StatusPaidHo == 3) ||
      (Type == 2 && StatusPaidHo == 1);
    let isShowPhiKho = showPhiKho && Type !== 2 && Type !== 1;
    return List.map((item, index) => {
      var lstTP = [];
      if (item.ThuPaid) lstTP = item.ThuPaid.split(",");
      return (
        <div class="custom-table-row">
          <div class="custom-table-cell username-cell flex-basis-8 disk-mobile">
            <span class="mobile-column-name">STT</span>
            <div class="center-wrapper">
              <p class="text-center">{item.IndexId}</p>
            </div>
          </div>

          <div class="row-show-three">
            <div class="row-mobile">
              <div class="custom-table-cell flex-basis-10">
                <span class="mobile-column-name disk-mobile">Thời gian</span>
                <div class="center-wrapper">
                  <p class="icon-dropdown-mobile">
                    <i
                      class="mdi mdi-arrow-down-drop-circle collapsible"
                      onClick={this.showRow(item)}
                    ></i>
                    {getDate(item.Time)}
                  </p>
                </div>
              </div>
              {showLai && (
                <div class="custom-table-cell flex-basis-12  flex-basis-12-responsive flex-disk">
                  <span class="mobile-column-name disk-mobile">Tiền lãi</span>
                  <div class="center-wrapper">
                    <p class="text-right1">{formatNumber(item.ValuePaid)}</p>
                  </div>
                </div>
              )}
            </div>

            <div
              class="form-row-detail content12"
              style={{
                display:
                  itemShow.isShow && (!itemShow.item || itemShow.item === item)
                    ? itemShow.displayText
                    : "none",
              }}
            >
              {showTienGop && (
                <div class="custom-table-cell flex-basis-12  flex-basis-12-responsive flex-disk">
                  <span class="mobile-column-name">Tiền góp</span>
                  <div class="center-wrapper">
                    <p class="text-right1">
                      {formatNumber(item.ValuePaid + item.ValueGoc)}
                    </p>
                  </div>
                </div>
              )}
              <div class="custom-table-cell flex-basis-12  flex-basis-12-responsive flex-disk">
                <span class="mobile-column-name">Phí hàng kỳ</span>
                <div class="center-wrapper">
                  <p class="text-right1">{formatNumber(item.OtheFeeHangKy)}</p>
                </div>
              </div>

              {showGoc && (
                <div class="custom-table-cell flex-basis-15 flex-basis-15-responsive">
                  <span class="mobile-column-name">Tiền gốc</span>
                  <div class="center-wrapper">
                    <p class="text-right1">{formatNumber(item.ValueGoc)}</p>
                  </div>
                </div>
              )}

              {isShowPhiKho && (
                <div class="custom-table-cell flex-basis-7-5  flex-basis-7-5-sm">
                  <span class="mobile-column-name">Phí kho</span>
                  <div class="center-wrapper">
                    <p class="text-right">{formatNumber(item.PhiKho)}</p>
                  </div>
                </div>
              )}
              <div class="custom-table-cell flex-basis-12  flex-basis-12-sm">
                <span class="mobile-column-name">Phí khác</span>
                <div class="center-wrapper">
                  <p class="text-right">{formatNumber(item.OtheFee)}</p>
                </div>
              </div>
              {showGop && (
                <div class="custom-table-cell flex-basis-15  flex-basis-15-responsive flex-disk">
                  <span class="mobile-column-name">Cần thanh toán</span>
                  <div class="center-wrapper">
                    <p class="text-right1">
                      {formatNumber(
                        item.ValuePaid + item.ValueGoc + item.OtheFeeHangKy,
                      )}
                    </p>
                  </div>
                </div>
              )}

              <div class="custom-table-cell flex-basis-15 flex-basis-15-responsive ">
                <span class="mobile-column-name">Số tiền đã trả</span>
                <div class="center-wrapper">
                  <p class="text-right color-xanh-bold">
                    {formatNumber(item.Paided)}
                  </p>
                </div>
              </div>
              <div class="custom-table-cell flex-basis-15  ">
                <span class="mobile-column-name">Các lần đóng</span>
                <div class="center-wrapper">
                  {lstTP.map((itemPaid, idexTP) => {
                    var itemPaids = itemPaid.split("#");
                    if (itemPaids.length > 3) {
                      if (itemPaids[3] == "False") {
                        return;
                      }
                    }
                    return (
                      <p class="text-center">
                        <a href={() => false}>
                          {formatNumber(itemPaids[2]).replace(".00", "")}
                        </a>
                        <br />{" "}
                        <span class="date-sm">({getDate(itemPaids[1])})</span>
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  render() {
    let {
      TongTienLai,
      TongTienGoc,
      TongPhiKho,
      TongPhiKhac,
      TongThanhToan,
      List,
      pageIndex,
      totalRow,
      pageSize,
      handlePageChange,
      showPhiKho,
      Type,
      StatusPaidHo,
      TongPhiKhacHangKy,
    } = this.props;
    let showLai =
      Type !== 2 ||
      (Type === 2 && StatusPaidHo === 2) ||
      (StatusPaidHo === 3 && Type === 2);
    let showGoc =
      Type !== 2 ||
      (Type === 2 && StatusPaidHo === 2) ||
      (StatusPaidHo === 3 && Type === 2);
    let showGop =
      (Type === 2 && StatusPaidHo === 3) ||
      (Type === 3 && StatusPaidHo === 3) ||
      (Type == 2 && StatusPaidHo == 1);
    let isShowPhiKho = showPhiKho && Type !== 2 && Type !== 1;
    let showTienGop = StatusPaidHo === 1 && Type === 2;
    return (
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="Left808x200 Table-main-new col-xl-12 col-lg-12">
          <div className="table-responsive table-responsive-new table-new1   table-rounded">
            <div className="custom-table-wrapper custom-border-mm">
              <div className="table-headers">
                <div className="custom-table-header flex-basis-8">
                  <p className="text-center">
                    <span className="color-do-bold">
                      [ {totalRow} ] <br /> &nbsp;
                    </span>
                  </p>
                </div>
                <div className="custom-table-header flex-basis-10   ">
                  <span className="color7-bold">Thời gian</span>
                </div>
                {showLai && (
                  <div className="custom-table-header flex-basis-12 flex-basis-12-responsive">
                    <p className="text-right">
                      Tiền lãi
                      <br />
                      <PopoversBootrap
                        contentText={formatNumber(TongTienLai)}
                        trigger={["hover", "focus"]}
                        placement={"bottom"}
                      >
                        <span className="color-cam-bold">
                          {formatCurrency(TongTienLai)}
                        </span>
                      </PopoversBootrap>
                    </p>
                  </div>
                )}
                {showTienGop && (
                  <div className="custom-table-header flex-basis-12 flex-basis-12-responsive">
                    <p className="text-right">
                      Tiền góp
                      <br />
                      <PopoversBootrap
                        contentText={formatNumber(TongTienGoc + TongTienLai)}
                        trigger={["hover", "focus"]}
                        placement={"bottom"}
                      >
                        <span className="color-do-bold">
                          {formatCurrency(TongTienGoc + TongTienLai)}
                        </span>
                      </PopoversBootrap>
                    </p>
                  </div>
                )}
                <div className="custom-table-header flex-basis-12 flex-basis-12-responsive">
                  <p className="text-right">
                    Phí hàng kỳ
                    <br />
                    <PopoversBootrap
                      contentText={formatNumber(TongPhiKhacHangKy)}
                      trigger={["hover", "focus"]}
                      placement={"bottom"}
                    >
                      <span className="color-cam-bold">
                        {formatCurrency(TongPhiKhacHangKy)}
                      </span>
                    </PopoversBootrap>
                  </p>
                </div>

                {showGoc && (
                  <div className="custom-table-header flex-basis-15 flex-basis-15-responsive">
                    <p className="text-right">
                      Tiền gốc
                      <br />
                      <PopoversBootrap
                        contentText={formatNumber(TongTienGoc)}
                        trigger={["hover", "focus"]}
                        placement={"bottom"}
                      >
                        <span className="color-do-bold">
                          {formatCurrency(TongTienGoc)}
                        </span>
                      </PopoversBootrap>
                    </p>
                  </div>
                )}

                {isShowPhiKho && (
                  <div className="custom-table-header flex-basis-7-5 flex-basis-7-5-sm">
                    <p className="text-right">
                      Phí kho <br />
                      <PopoversBootrap
                        contentText={formatNumber(TongPhiKho)}
                        trigger={["hover", "focus"]}
                        placement={"bottom"}
                      >
                        <span className="color-do-bold">
                          {formatCurrency(TongPhiKho)}
                        </span>
                      </PopoversBootrap>
                    </p>
                  </div>
                )}
                <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                  <p className="text-right">
                    Phí khác <br />
                    <PopoversBootrap
                      contentText={formatNumber(TongPhiKhac)}
                      trigger={["hover", "focus"]}
                      placement={"bottom"}
                    >
                      <span className="color-do-bold">
                        {formatCurrency(TongPhiKhac)}
                      </span>
                    </PopoversBootrap>
                  </p>
                </div>
                {showGop && (
                  <div className="custom-table-header flex-basis-15 flex-basis-15-responsive">
                    <p className="text-right">
                      Cần thanh toán
                      <br />
                      <PopoversBootrap
                        contentText={formatNumber(
                          TongTienLai + TongTienGoc + TongPhiKhacHangKy,
                        )}
                        trigger={["hover", "focus"]}
                        placement={"bottom"}
                      >
                        <span className="color-do-bold">
                          {formatCurrency(
                            TongTienLai + TongTienGoc + TongPhiKhacHangKy,
                          )}
                        </span>
                      </PopoversBootrap>
                    </p>
                  </div>
                )}
                <div className="custom-table-header flex-basis-15 flex-basis-15-responsive">
                  <p className="text-right">
                    Số tiền đã trả <br />{" "}
                    <PopoversBootrap
                      contentText={formatNumber(TongThanhToan)}
                      trigger={["hover", "focus"]}
                      placement={"bottom"}
                    >
                      <span className="color-xanh-bold">
                        {formatCurrency(TongThanhToan)}
                      </span>
                    </PopoversBootrap>
                  </p>
                </div>
                <div className="custom-table-header flex-basis-15 ">
                  <p className="tab-header text-center">
                    Các lần đóng
                    <br />
                    &nbsp;
                  </p>
                </div>
              </div>

              <div className="custom-table-body">
                <div className="custom-table-row">
                  <div className="custom-table-cell username-cell-mobile flex-basis-12 flex-disk disk-desktop show-mobile">
                    <span class="mobile-column-name">Ngày trả lãi</span>
                    <div className="center-wrapper  ">
                      <p className="text-right1">Tiền lãi</p>
                    </div>
                  </div>
                </div>
                {this.renderRow(List)}
              </div>
            </div>
          </div>
        </div>
        <div className="footer-page-new col-xl-12 col-lg-12">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="paniation-new d-flex just-end">
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={totalRow}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default LanThanhToanView;
